import React from'react';
import { useAuth } from'../context/AuthContext';
import { useQueryClient } from'@tanstack/react-query';
import api from'../api/client';
import ModelPricingEditor from'../components/cost/ModelPricingEditor';
import Breadcrumbs from'../components/Breadcrumbs';
import ErrorBoundary from'../components/ErrorBoundary';
import { Settings as SettingsIcon, RefreshCw, Loader2 } from'lucide-react';

export default function Settings() {
 const { user } = useAuth();
 const queryClient = useQueryClient();
 const [clearing, setClearing] = React.useState(false);

 const handleClearCache = async () => {
 setClearing(true);
 try {
 await api.clearCache();
 queryClient.invalidateQueries();
 } catch (err) {
 alert('Failed to clear cache:' + (err.message ||'Unknown error'));
 } finally {
 setClearing(false);
 }
 };

 return (
 <div className="space-y-8">
 <Breadcrumbs />
 <div>
 <h1 className="text-xl font-bold flex items-center gap-2">
 <SettingsIcon className="w-5 h-5" />
 Settings
 </h1>
 <p className="text-sm text-gray-500 mt-0.5">
 Configure pricing, caching, and platform preferences
 </p>
 </div>

 {/* Pricing Section */}
 <section>
 <ErrorBoundary>
 <ModelPricingEditor />
 </ErrorBoundary>
 </section>

 {/* Cache Management */}
 <section className="chart-container">
 <h2 className="text-lg font-semibold mb-3">Cache Management</h2>
 <p className="text-sm text-gray-500 mb-4">
 Clear server-side cached data. The platform caches KQL query results and APIM metadata 
 to reduce load. Use this if data appears stale.
 </p>
 <button
 onClick={handleClearCache}
 disabled={clearing}
 className="px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-lg
 hover:bg-amber-700 transition disabled:opacity-50 flex items-center gap-2"
 >
 {clearing
 ? <Loader2 className="w-4 h-4 animate-spin" />
 : <RefreshCw className="w-4 h-4" />}
 Clear All Caches
 </button>
 </section>

 {/* Session Info */}
 <section className="chart-container">
 <h2 className="text-lg font-semibold mb-3">Session Info</h2>          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
 <div>
 <span className="text-gray-400">Name</span>
 <div className="font-medium">{user?.name ||'—'}</div>
 </div>
 <div>
 <span className="text-gray-400">Email</span>
 <div className="font-medium">{user?.email ||'—'}</div>
 </div>
 <div>
 <span className="text-gray-400">Roles</span>
 <div className="font-medium">{(user?.roles || []).join(',') ||'No roles'}</div>
 </div>
 <div>              <span className="text-gray-400">Tenant ID</span>
              <div className="font-mono text-xs break-all">{user?.tenantId ||'—'}</div>
 </div>
 </div>
 </section>
 </div>
 );
}
